import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
@Injectable()
export class AuthorizationGuard implements CanActivate {
  groupId = (localStorage.getItem("group_id") == null || localStorage.getItem("group_id") == undefined) ? 0 : parseInt(localStorage.getItem("group_id"));

  constructor(private oauthService: OAuthService, private router: Router) {    
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {  
    if (this.oauthService.hasValidAccessToken()) {
      return true;
    }
    this.router.navigateByUrl(''+this.groupId);
    return false;
  }
}